import React, { useEffect, useState } from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import { Link } from 'react-router-dom'
import AOS from "aos";
import "aos/dist/aos.css";
import { useFormik } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getCourseData, getHomeFindTutorData, getHomeTutorListData, getHomeTutorViewData } from '../../../Redux/action/MasterAction';
import Beatloader from '../../../Common/BeatLoader';
import { jwtDecode } from "jwt-decode";
import FeedbackForm from '../../FeedbackForm/FeedbackForm';
import { Modal } from 'react-bootstrap';
import SkeletonLoaderHeroMentors from '../../../Common/skeleton/FindTutor/SkeletonLoaderHeroMentors';
import ResponsivePagination from '../../../Common/Pagination';


const host = process.env.REACT_APP_API_SERVER
const FindTutor = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getHomeTutorListData(''))
        dispatch(getCourseData())
        dispatch(getHomeFindTutorData());

    }, []);





    const {

        loadingHomeTutorViewDataListApi,
        HomeTutorViewDataListApiData,
        HomeTutorViewDataListApiError,

        loadingHomeFindTutorDataApi,
        HomeFindTutorDataApiData,
        HomeFindTutorDataApiError,

        loadingHomeTutorListDataListApi,
        HomeTutorListDataListApiData,
        HomeTutorListDataListApiError,

        loadingCourseDataListApi,
        CourseDataListApiData,
        CourseDataListApiError,
    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {
        AOS.init({
            disable: "phone",
            duration: 700,
            easing: "fade-up",
        });
    }, []);





    // Formik setup
    const formik = useFormik({
        initialValues: {
            gender: [],
            courses: [],
        },
        onSubmit: (values) => {
            // Update query params
            const query = new URLSearchParams();

            // Add selected filters to query
            if (values.gender.length > 0) {
                query.append("gender", values.gender.join(","));
            }
            if (values.courses.length > 0) {
                query.append("courses", values.courses.join(","));
            }

            // Update the URL
            navigate({ search: query.toString() });

            // Dispatch API call with updated query
            dispatch(getHomeTutorListData(query.toString()));
        },
    });

    // Trigger API call on query params change
    useEffect(() => {
        const gender = queryParams.get("gender")?.split(",") || [];
        const courses = queryParams.get("courses")?.split(",") || [];

        // Set values in the form based on query params
        formik.setValues({ gender, courses });

        // Fetch data based on query params
        dispatch(getHomeTutorListData(queryParams.toString()));
    }, [location.search]);


    //pagination

    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!HomeTutorListDataListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(HomeTutorListDataListApiData.slice(start, end));
        setPageCount(Math.ceil(HomeTutorListDataListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, HomeTutorListDataListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    const handleNavigation = () => {
        const token = localStorage.getItem('student-token')
        if (token) {
            const decoded = jwtDecode(token);

            if (decoded?.user?.id) {
                navigate('/student/dashboard')
            }
            else {
                navigate('/login', { state: { user: 'student' } })
            }
        }
        else {
            navigate('/login', { state: { user: 'student' } })
        }

    }
    const [showModal, setShowModal] = useState(false);

    const handleModalClick = (id) => {
        setShowModal(true)
        dispatch(getHomeTutorViewData(id))
    }


    return (
        <div className='pagination-component'>

            <>
                <Header />
                <FeedbackForm />
                {loadingHomeFindTutorDataApi ?
                    <section className="hero-wrap style1 ">
                        <div className="container">
                            <SkeletonLoaderHeroMentors />
                        </div>
                    </section>
                    :
                    <><section className="hero-wrap style1 ">
                        <div className="container">
                            <div className="hero-section ">
                                <div className="row" style={{ marginBottom: 80 }}>
                                    <div className="col-lg-7 col-md-7 col-sm-7 headi home-slide-text">
                                        <h1>{HomeFindTutorDataApiData?.find_tutor_title}</h1>
                                        <div>
                                            <p>
                                                {HomeFindTutorDataApiData?.find_tutor_subtitle}
                                                <br />
                                                <span className='mt-2'> Search for the perfect tutors for you.</span>
                                            </p>

                                        </div>
                                        <form id="tutorForm" className="tutorform">
                                            {/* <select id="tutorSelect" name="tutor">
        <option value="tutor1">English</option>
        <option value="tutor2">Spanish</option>
        <option value="tutor3">French</option>
        <option value="tutor4">German</option>
    </select> */}
                                            <a
                                                onClick={handleNavigation}
                                                className="btn btn-primary text-white mt-3 "

                                            >
                                                Get Started
                                            </a>
                                        </form>
                                    </div>
                                    <div className="col-lg-5 col-md-5 col-sm-5 headi">
                                        <img
                                            src={`${host}${HomeFindTutorDataApiData?.find_tutor_image}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section><section className="mentors">
                            <div className="heading" style={{ marginTop: 0 }} data-aos="fade-up">
                                <img src="/website/assets/img/secion-shape-1.png" alt="Image" />{" "}
                                <span className="ruby">
                                    <h2>FIND TUTORS </h2>
                                </span>
                                <img src="/website/assets/img/secion-shape-2.png" alt="Image" />
                            </div>
                            <div className="container" style={{ marginBottom: 80 }}>
                                <div className="content" style={{ transform: "none", minHeight: 326 }}>
                                    <div className="container-fluid" style={{ transform: "none" }}>
                                        <div className="row" style={{ transform: "none" }}>
                                            <div
                                                className="col-md-12 col-lg-4 col-xl-3 theiaStickySidebar mb-5"
                                                style={{
                                                    position: "relative",
                                                    overflow: "visible",
                                                    boxSizing: "border-box",
                                                    minHeight: 1
                                                }}
                                            >
                                                <div
                                                    className="theiaStickySidebar"
                                                    style={{
                                                        paddingTop: 0,
                                                        paddingBottom: 1,
                                                        position: "static",
                                                        transform: "none"
                                                    }}
                                                >
                                                    <div className="card search-filter">
                                                        <div className="card-header">
                                                            <h4 className="card-title mb-0">Search Filter</h4>
                                                        </div>
                                                        <div className="card-body">
                                                            {/* <div className="filter-widget">

        Clear Filter

    </div> */}
                                                            <form onSubmit={formik.handleSubmit}>
                                                                {/* Gender Filter */}
                                                                <div className="filter-widget">
                                                                    <h4>Gender</h4>
                                                                    {["Male", "Female", "Other"].map((gender, index) => (
                                                                        <div key={index + 1}>
                                                                            <label className="custom_check">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name="gender"
                                                                                    value={gender}
                                                                                    onChange={(e) => {
                                                                                        const { value } = e.target;
                                                                                        let updatedGender = [...formik.values.gender];
                                                                                        if (updatedGender.includes(value)) {
                                                                                            updatedGender = updatedGender.filter((g) => g !== value);
                                                                                        } else {
                                                                                            updatedGender.push(value);
                                                                                        }
                                                                                        formik.setFieldValue("gender", updatedGender);
                                                                                        formik.handleSubmit();
                                                                                    }}
                                                                                    checked={formik.values.gender.includes(gender)} />
                                                                                <span className="checkmark" />
                                                                                {gender}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                                {/* Courses Filter */}
                                                                <div className="filter-widget">
                                                                    <h4>Select Courses</h4>
                                                                    <div className='div-flow'>
                                                                        {CourseDataListApiData?.map((course) => (
                                                                            <div key={course.id}>
                                                                                <label className="custom_check">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        name="courses"
                                                                                        value={course.id}
                                                                                        onChange={(e) => {
                                                                                            const { value } = e.target;
                                                                                            let updatedCourses = [...formik.values.courses];
                                                                                            if (updatedCourses.includes(value)) {
                                                                                                updatedCourses = updatedCourses.filter((c) => c !== String(value));
                                                                                            } else {
                                                                                                updatedCourses.push(value);
                                                                                            }
                                                                                            formik.setFieldValue("courses", updatedCourses);
                                                                                            formik.handleSubmit();
                                                                                        }}

                                                                                        checked={formik.values.courses.includes(String(course.id))} />
                                                                                    <span className="checkmark" />
                                                                                    {course.name}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>

                                                                {/* Submit Button (optional) */}
                                                                {/* <div className="btn-search">
        <button type="submit" className="btn btn-block w-100">
            Search
        </button>
    </div> */}
                                                            </form>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="resize-sensor"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            overflow: "hidden",
                                                            zIndex: -1,
                                                            visibility: "hidden"
                                                        }}
                                                    >
                                                        <div
                                                            className="resize-sensor-expand"
                                                            style={{
                                                                position: "absolute",
                                                                left: 0,
                                                                top: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                overflow: "hidden",
                                                                zIndex: -1,
                                                                visibility: "hidden"
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    left: 0,
                                                                    top: 0,
                                                                    transition: "all",
                                                                    width: 361,
                                                                    height: 1194
                                                                }} />
                                                        </div>
                                                        <div
                                                            className="resize-sensor-shrink"
                                                            style={{
                                                                position: "absolute",
                                                                left: 0,
                                                                top: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                overflow: "hidden",
                                                                zIndex: -1,
                                                                visibility: "hidden"
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    left: 0,
                                                                    top: 0,
                                                                    transition: "0s",
                                                                    width: "200%",
                                                                    height: "200%"
                                                                }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {loadingHomeTutorListDataListApi ?
                                                <Beatloader />
                                                :
                                                <div className="col-md-12 col-lg-8 col-xl-9 h-100">
                                                    {HomeTutorListDataListApiData?.length > 0 ?
                                                        currentData?.map((data) => (
                                                            <div key={data?.id} className="card" data-aos="fade-up">
                                                                <div className="card-body">
                                                                    <div className="mentor-widget">
                                                                        <div className="user-info-left">
                                                                            <div className="mentor-img">
                                                                                <a onClick={() => { handleModalClick(data?.id); }}>
                                                                                    <img
                                                                                        onError={(e) => {
                                                                                            e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                                        }}
                                                                                        src={`${host}${data?.image}`}
                                                                                        className="img-fluid"
                                                                                        alt="User Image" />
                                                                                </a>
                                                                            </div>
                                                                            <div className="user-info-cont" onClick={() => { handleModalClick(data?.id); }} style={{ cursor: 'pointer' }}>

                                                                                <h4 className="usr-name">
                                                                                    <a>{data?.name}</a>
                                                                                </h4>
                                                                                <p className="mentor-type">{data?.specialization}</p>
                                                                                <div className="rating">
                                                                                    {Array.from({ length: 5 }, (_, index) => {
                                                                                        if (index < Math.floor(data?.avg_rating || 0)) {
                                                                                            return <i key={index} className="fas fa-star filled" />;
                                                                                        } else if (index < data?.avg_rating) {
                                                                                            return <i key={index} className="fas fa-star-half-alt filled" />;
                                                                                        } else {
                                                                                            return <i key={index} className="fas fa-star" />;
                                                                                        }
                                                                                    })}
                                                                                    <span className="d-inline-block average-rating">
                                                                                        ({data?.total_rating || 0})
                                                                                    </span>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                        <div className="user-info-right">
                                                                            <div className="user-infos">
                                                                                <ul>
                                                                                    <li>
                                                                                        <i className="far fa-comment" />
                                                                                        {data?.total_rating} Feedback
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-map-marker-alt" />
                                                                                        {data?.state}{data?.country ? `, ${data?.country}` : ''}
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="far fa-money-bill-alt" />
                                                                                        {data?.firstPrice == data?.secondPrice ?
                                                                                            <span>${data?.firstPrice}</span>
                                                                                            :
                                                                                            <span>
                                                                                                ${data?.firstPrice} - ${data?.secondPrice}
                                                                                            </span>}{" "}

                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                            <div className="mentor-booking">
                                                                                <a onClick={handleNavigation} className="apt-btn">
                                                                                    Book Appointment
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>}
                                                        
                                                    {pageCount > 1 && (
                                                        <ResponsivePagination
                                                            pageCount={pageCount}
                                                            currentPage={currentPage}
                                                            handlePageClick={handlePageClick}
                                                        />
                                                    )}
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section></>
                }
                <Footer />
            </>
            <>

                {/* Tutor Details Modal */}
                <Modal show={showModal}
                    onHide={() => setShowModal(false)} style={{ zIndex: '10000' }}>

                    {loadingHomeTutorViewDataListApi ?
                        <Beatloader /> :
                        <div className="modal-content" >
                            <Modal.Header closeButton>
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Tutor Details
                                </h5>

                            </Modal.Header>
                            <div className="modal-body">
                                <div className="row mb-2">
                                    <div className="col-lg-4">
                                        <img
                                            onError={(e) => {
                                                e.target.src = '/assets/img/user/user.png'; // Fallback image
                                            }}
                                            src={`${host}${HomeTutorViewDataListApiData?.image}`}
                                            className="img-fluid"
                                            style={{ height: "7.6rem", width: "auto" }}
                                        />
                                    </div>
                                    <div className="col-lg-8 col-md-8" style={{ width: "fit-content" }}>
                                        <h5 className="mb-0">{HomeTutorViewDataListApiData?.name}</h5>
                                        {HomeTutorViewDataListApiData?.tutordetails?.experience && <p className="mb-0">Experience: {HomeTutorViewDataListApiData?.tutordetails?.experience} Years</p>}
                                        <p className="mb-0">Ratings</p>
                                        <div className="rating">
                                            {Array.from({ length: 5 }, (_, index) => {
                                                const averageRating = parseFloat(HomeTutorViewDataListApiData?.avarageRating || "0"); // Convert to number
                                                if (index < Math.floor(averageRating)) {
                                                    return <i key={index} className="fas fa-star filled ms-1" />;
                                                } else if (index < averageRating) {
                                                    return <i key={index} className="fas fa-star-half-alt filled ms-1" />;
                                                } else {
                                                    return <i key={index} className="fas fa-star ms-1" />;
                                                }
                                            })}

                                            <span className='ms-1'>
                                                {HomeTutorViewDataListApiData?.avarageRating} <span className="text-primary">({HomeTutorViewDataListApiData?.reviewCount} Ratings)</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {HomeTutorViewDataListApiData?.tutorteachingdetails?.length > 0 &&
                                    <div className="row mt-3">
                                        <div className="col-lg-12 mb-2">
                                            <p className="mb-0">Subject</p>
                                            <h6>
                                                {[...new Set(HomeTutorViewDataListApiData?.tutorteachingdetails?.map(data => data?.sub_category?.name))]
                                                    .filter(Boolean) // Remove null or undefined values
                                                    .map((name, index, uniqueNames) => (
                                                        <span key={index}>
                                                            {name}
                                                            {index !== uniqueNames.length - 1 && ", "}
                                                        </span>
                                                    ))}

                                            </h6>

                                        </div>
                                    </div>}
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <p className="mb-0">Tutoring</p>
                                    </div>
                                    <div className="col-lg-10">
                                        <h6>One to One</h6>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>${HomeTutorViewDataListApiData?.tutordetails?.per_session_price_one_to_one}</p>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <p className="mb-0">Group Tutoring</p>
                                    </div>
                                    <div className="col-lg-10">
                                        <h6>Group Class</h6>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>${HomeTutorViewDataListApiData?.tutordetails?.per_session_price_group}</p>
                                    </div>
                                </div>
                                <div></div>
                            </div>

                        </div>}

                </Modal>
            </>
        </div>
    )
}

export default FindTutor